<template>
	<div class="notebook" :class="{ shaking: shaking }">
		<div class="notebook-bg"></div>
		
		<div class="notebook-content">
			
			<div class="player">
				<div class="name">Santé</div>
				<div class="life">
					<div v-for="i in game.player.life_max" class="heart">
						<div class="heart-empty"><icon file="heart" :size="20" /></div>
						<transition name="heart">
							<div v-show="i <= game.player.life" class="heart-full"><icon file="heart" :size="20" /></div>
						</transition>
					</div>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
// import 'simplebar'
// import "simplebar/dist/simplebar.css"

export default {
	name: 'Phase',
	data () {
		return {
			shaking: false
		}
	},
	computed: Object.assign(mapGetters([ 'game' ]), {
		
	}),
	watch: {
		'game.player.life': function(newValue, oldValue) {
			if (newValue < oldValue) {
				var that = this
				this.shaking = true
				setTimeout(function() {
					that.shaking = false
				}, 500)
			}
		}
	}
}
</script>

<style lang="stylus">
@import '../assets/css/app'

.notebook
	display inline-block
	margin 0 0 180px 24px
	width 200px
	height 200px
	font-size 20px
	font-family 'Averia Libre', 'Inconsolata'
	line-height 22px
	&.shaking
		animation shake 0.25s infinite cubic-bezier(.36,.07,.19,.97) both
	&:before, .notebook-bg, .notebook-content
		content ''
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		background lighten(lightyellow, 80%)
		transform rotate(2deg)
		border-radius 2px
		box-shadow -1px 2px 0 0 alpha(dark, 8%), 1px -2px 0 0 alpha(dark, 8%), 4px 6px 0 0 alpha(dark, 8%)
	.notebook-bg
		transform rotate(-1deg) translateY(-1px)
	.notebook-content
		transform none
		background lighten(lightyellow, 80%)
		padding 32px
		.player
			display block
			.name
				display block
				margin 0 0 8px 0
			.life
				display flex
				align-items center
				justify-content flex-start
				flex-wrap wrap
				.heart
					margin 1px
					.heart-empty
						color alpha(dark, 20%)
					.heart-full
						position absolute
						left 0
						top 0
						color red
						// transition 0.5s easeOutQuart
						&.heart-leave-active
							transition 0.75s easeOutQuart
							transition-delay 0.25s
						&.heart-leave-to
							opacity 0
							transform scale(4)
					.icon
						display block
				
@keyframes shake
	10%, 90%
		transform translate3d(-1px, 3px, 0)

	20%, 80%
		transform translate3d(2px, -2px, 0)

	30%, 50%, 70%
		transform translate3d(-4px, 3px, 0)

	40%, 60%
		transform translate3d(4px, -3px, 0)

	
</style>



// WEBPACK FOOTER //
// src/components/Notebook.vue